import { Component, OnInit, Input, Output, OnChanges, EventEmitter,Injectable} from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
import { MedicalHistory } from '../../master/model/medical-history' ;
import { Patient,PatientMedicalHistory } from '../model/patient';
import { PatientService } from '../service/patient-service.service';
import { MedicalHistoryService } from '../../master/services/medical-history.service'; 
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
@Component({
  selector: 'app-view-medical-history',
  templateUrl: './view-medical-history.component.html',
  styleUrls: ['./view-medical-history.component.css']
})
export class ViewMedicalHistoryComponent implements OnInit {
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() visibleSave: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() editDialogVisible : boolean = false;
  @Input() patient : Patient ;
  @Input() medical : MedicalHistory ;
  MedicalHistoryList : PatientMedicalHistory[] ;
  patientMedicalHistiory : PatientMedicalHistory
  isErrorMessage : boolean = false;
  isSuccessMessage : boolean = false;
  patientInfo : Patient;
  Mloading : boolean = false;
  message : string;
  selectedObject : PatientMedicalHistory;
  user:any;
  constructor(private _sharedService: SharedService, private _usrService : PatientService) { 
     this.patientMedicalHistiory = new PatientMedicalHistory(null,null,'');
     _sharedService.yesEmitted$.subscribe(
      text => {
          if(text.Action===DialogAction.DELETE.toString() && text.Page === 'PATIENTMEDICAL' ) {
              this.deletePatientMedical( this.selectedObject);
          }  
      });
  }
  hideMessage() : void {
    setTimeout(() => {
      this.isErrorMessage  = false;
      this.isSuccessMessage  = false;   
      this.message = '';
    }, 2000);
  }
  AddMedicalHistory() : void {
    if(this.patientMedicalHistiory.MedicalHistoryId === null) {
      this.message = "Please select medical history!";
      this.isErrorMessage  =true;
      this.hideMessage() ;
       return;
    }
      this.Mloading = true;
       this._usrService.medicalData = this.patientMedicalHistiory;
      this.isErrorMessage  = false;
      this.isSuccessMessage  = false;   
      this._usrService.createPatientMedicalHistory().subscribe(data=>{
        this.Mloading = false;
        this.message = "User Medical History "+ ActionMessage.SAVESUCCESS.toString();
        this.isSuccessMessage  =true;
        this.patientMedicalHistiory.MedicalHistoryId = null;
        this.hideMessage() ;
        this.GetPatientMedicalHistory();
      },
      error=>{
          this.Mloading = false;
          this.message = error._body;
          this.isErrorMessage  =true;
          this.hideMessage() ;
      });
  }
  GetPatientMedicalHistory() : void {
    this.Mloading = true;
      this._usrService.getPatientMedicalHistory(this.patientInfo.PatientId).subscribe(data=>{
        this.MedicalHistoryList = data;
        this.Mloading = false;
    },
    error=>{
      this.Mloading = false;
    });
  }
  deletePatientMedicalConfirm(item : PatientMedicalHistory) {
    this.selectedObject = item;
    this._sharedService.emitDialog(true,"Delete",ActionMessage.DELETE.toString(),true,DialogAction.DELETE.toString(),'PATIENTMEDICAL' );   
  }
  deletePatientMedical(item : PatientMedicalHistory) : void {
      if(item.PatientId === undefined) {
        return;
      }
    this.Mloading = true;
    this._usrService.deletePatientMedicalHistory(item).subscribe(data=>{
        this.Mloading = false;
        this.GetPatientMedicalHistory();
    },
    error=>{
      this.Mloading = false;
    });
  }
  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
      this.patientInfo = this.patient;
      if(this.patientInfo !== undefined && this.patientInfo !== null) {
        this.patientMedicalHistiory.PatientId = this.patientInfo.PatientId;
        this.GetPatientMedicalHistory();
      }
     
  }
  close() {   
    this.editDialogVisible = false;   
    this.visibleChange.emit(this.editDialogVisible);
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
}




// WEBPACK FOOTER //
// ./src/app/section/patient/view-medical-history/view-medical-history.component.ts